module.exports = __webpack_public_path__ + "img/aim.f3f2fc5c.svg";